import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../services/analytics.service';

@Directive({
  selector: '[appTrackClick]',
  standalone: true
})
export class TrackClickDirective {
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly analytics = inject(AnalyticsService);
  private readonly router = inject(Router);

  @Input('appTrackClick') label = '';
  @Input() trackClickEvent?: string;
  @Input() trackClickContext?: string;
  @Input() trackClickDestination?: string;

  @HostListener('click')
  handleClick(): void {
    const element = this.element.nativeElement;
    const label = this.label.trim();
    if (!label) {
      return;
    }

    const destination = this.trackClickDestination ?? this.resolveDestination(element);
    this.analytics.trackClick(label, {
      eventName: this.trackClickEvent,
      location: this.router.url,
      destination,
      element: element.tagName.toLowerCase(),
      context: this.trackClickContext
    });
  }

  private resolveDestination(element: HTMLElement): string | undefined {
    if (element instanceof HTMLAnchorElement) {
      return element.getAttribute('href') ?? undefined;
    }
    return undefined;
  }
}
